export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7992.6657ef99.jpg";